/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalFormSubmitted/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MedicalFormSubmitted({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/MedicalFormSubmitted"
  
}) {
  return null
}